import React from 'react';
import { Box, Center } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

// Define the keyframes using @emotion/react's keyframes utility
const rotate = keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(60px, 0) rotate(90deg);
  }
  50% {
    transform: translate(60px, 60px) rotate(180deg);
  }
  75% {
    transform: translate(0, 60px) rotate(270deg);
  }
  100% {
    transform: translate(0, 0) rotate(360deg);
  }
`;

const RotatedSquareLoader = () => {
  return (
    <Center h="100vh" bgColor="#000">
      <Box position="relative" width="40px" height="40px">
        <Box
          position="absolute"
          top="0"
          left="0"
          width="20px"
          height="40px"
          bg="red.500"
          borderRadius="32px"
          animation={`${rotate} 1.5s infinite`}
        />
        <Box
          position="absolute"
          top="0"
          right="0"
          width="20px"
          height="40px"
          bg="green.500"
          borderRadius="32px"
          animation={`${rotate} 1.5s infinite 0.4s`}
        />
        <Box
          position="absolute"
          bottom="0"
          right="0"
          width="20px"
          height="40px"
          bg="#3A98FB"
          borderRadius="32px"
          animation={`${rotate} 1.5s infinite 0.8s`}
        />
        <Box
          position="absolute"
          bottom="0"
          left="0"
          width="20px"
          height="40px"
          bg="yellow.500"
          borderRadius="32px"
          animation={`${rotate} 1.5s infinite 1.2s`}
        />
      </Box>
    </Center>
  );
};

export default RotatedSquareLoader;
